import React from "react";
import clsx from "clsx";
import { Button } from "@material-ui/core";
import useStyles from "../../styles/submitBtnStyle";
import CircularProgress from "@material-ui/core/CircularProgress";

const SubmitBtn = props => {
  const classes = useStyles();
  const {
    loading,
    success,
    variant,
    size,
    color,
    href,
    disabled,
    startIcon,
    fullWidth,
    onClick,
    children,
    className,
    style
  } = props;

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success
  });

  const handleClick = () => {
    if (loading) return;
    onClick?.();
  };

  return (
    <Button
      variant={variant}
      size={size}
      type="submit"
      color={color}
      fullWidth={fullWidth}
      className={`${classes.btn} ${buttonClassname} ${className}`}
      href={href}
      disabled={disabled}
      startIcon={loading ? <CircularProgress size={18} /> : startIcon}
      onClick={handleClick}
      style={
        loading ? { ...style, opacity: 0.7, pointerEvents: "none" } : style
      }
    >
      {children}
    </Button>
  );
};

export default SubmitBtn;
